import { FormControlLabel, Radio } from '@mui/material';

import { LabelRadioProps } from './props';

const LabelRadio = ({
  radioProps,
  checked = false,
  ...props
}: LabelRadioProps) => {
  return (
    <FormControlLabel
      className="flex"
      sx={{
        margin: 0,
        alignItems: 'center',
      }}
      {...props}
      control={<Radio {...radioProps} />}
    />
  );
};

export default LabelRadio;
